
import Navigation from "../components/Navigation"

const styles = {
    colors: {
        primary: '#2563eb', // Royal blue - represents trust and professionalism
        secondary: '#7c3aed', // Purple - innovation and creativity
        accent: '#f59e0b', // Amber - energy and positivity
        text: {
            primary: '#1f2937', // Dark gray for main text
            secondary: '#4b5563', // Medium gray for secondary text
            light: '#9ca3af', // Light gray for tertiary text
        },
        background: {
            light: '#ffffff',
            subtle: '#f8fafc',
            gradient: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
        }
    },
    spacing: {
        section: 'py-24',
        container: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8',
    }
};

export default function Robotics(params) {

    return (<>
        <div class="bg-gradient-to-b from-blue-50 to-indigo-50 min-h-screen">
            <Navigation />

            <section class="py-12 px-4" style={{ paddingTop: '9rem' }}>
                <div class="container mx-auto flex flex-col md:flex-row items-center">
                    <div class="md:w-1/2 mb-8 md:mb-0">
                        <h2 class="text-4xl md:text-5xl font-bold text-neutral mb-4">Build, Code & Play with <span class="text-primary">Robots</span>!</h2>
                        <p class="text-lg text-neutral mb-6">A fun 30-session journey into the world of robotics designed specially for young innovators aged 8-14.</p>
                        <div class="flex space-x-4">
                            {/* <a href="#curriculum" class="bg-primary hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full shadow-lg transition duration-300">Explore Courses</a> */}
                            {/* <a href="#contact" class="bg-white hover:bg-gray-100 text-neutral font-bold py-3 px-6 rounded-full shadow-lg border border-gray-200 transition duration-300">Register Now</a> */}
                        </div>
                    </div>
                    <div class="md:w-1/2 flex justify-center">
                        <div class="relative w-80 h-80">
                            <div class="absolute top-0 left-0 w-full h-full bg-blue-200 rounded-full opacity-30 floating"></div>
                            <div class="absolute ">
                                {/* <img src="https://cdn-icons-png.flaticon.com/512/2593/2593278.png" alt="Robot" class="w-64 h-64 floating" /> */}
                                <img src="https://static.vecteezy.com/system/resources/previews/024/238/434/non_2x/ai-generated-small-robots-futuristic-marvels-of-artificial-intelligence-free-png.png" alt="Robot" class="w-82 h-82 floating" />
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="curriculum" class="py-12 bg-white px-4">
                <div class="container mx-auto">
                    <h2 class="text-3xl font-bold text-center text-neutral mb-2">Our <span class="text-primary">Robotics</span> Curriculum</h2>
                    <p class="text-center text-neutral mb-12 max-w-2xl mx-auto">30 sessions of hands-on learning divided into three exciting levels</p>

                    <div class="mb-16">
                        <div class="flex items-center mb-8">
                            <div class="bg-primary text-white rounded-full h-12 w-12 flex items-center justify-center text-xl font-bold mr-4">A</div>
                            <h3 class="text-2xl font-bold text-neutral">Basics (Sessions 1–10)</h3>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
                            {/* <!-- Session Cards --> */}
                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-primary mb-3"><i class="fas fa-info-circle"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 1</h4>
                                <p class="text-sm text-neutral">Introduction to Robotics</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-primary mb-3"><i class="fas fa-weight-hanging"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 2</h4>
                                <p class="text-sm text-neutral">Basic Physics for Robotics</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-primary mb-3"><i class="fas fa-bolt"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 3</h4>
                                <p class="text-sm text-neutral">Electricity Basics</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-primary mb-3"><i class="fas fa-microchip"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 4</h4>
                                <p class="text-sm text-neutral">Electronic Components I</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-primary mb-3"><i class="fas fa-cogs"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 5</h4>
                                <p class="text-sm text-neutral">Electronic Components II</p>
                            </div>
                        </div>

                        <div class="text-center mt-8">
                            <button class="text-primary font-medium flex items-center justify-center mx-auto">
                                See all 10 sessions <i class="fas fa-arrow-down ml-2"></i>
                            </button>
                        </div>
                    </div>

                    {/* <!-- Part B --> */}
                    <div class="mb-16">
                        <div class="flex items-center mb-8">
                            <div class="bg-secondary text-white rounded-full h-12 w-12 flex items-center justify-center text-xl font-bold mr-4">B</div>
                            <h3 class="text-2xl font-bold text-neutral">Intermediate (Sessions 11–20)</h3>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
                            {/* <!-- Session Cards --> */}
                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-secondary mb-3"><i class="fas fa-cogs"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 11</h4>
                                <p class="text-sm text-neutral">Introduction to Mechanisms</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-secondary mb-3"><i class="fas fa-tachometer-alt"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 12</h4>
                                <p class="text-sm text-neutral">Servo Motors & PWM</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-secondary mb-3"><i class="fas fa-satellite-dish"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 13</h4>
                                <p class="text-sm text-neutral">Sensors – Ultrasonic & IR</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-secondary mb-3"><i class="fas fa-robot"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 14</h4>
                                <p class="text-sm text-neutral">Mini Project – Obstacle Avoidance Car</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-secondary mb-3"><i class="fas fa-walking"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 15</h4>
                                <p class="text-sm text-neutral">Otto DIY Biped – Part 1</p>
                            </div>
                        </div>

                        <div class="text-center mt-8">
                            <button class="text-secondary font-medium flex items-center justify-center mx-auto">
                                See all 10 sessions <i class="fas fa-arrow-down ml-2"></i>
                            </button>
                        </div>
                    </div>

                    {/* <!-- Part C --> */}
                    <div>
                        <div class="flex items-center mb-8">
                            <div class="bg-accent text-white rounded-full h-12 w-12 flex items-center justify-center text-xl font-bold mr-4">C</div>
                            <h3 class="text-2xl font-bold text-neutral">Advanced (Sessions 21–30)</h3>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
                            {/* <!-- Session Cards --> */}
                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-accent mb-3"><i class="fas fa-satellite"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 21</h4>
                                <p class="text-sm text-neutral">Advanced Sensors & Data Fusion</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-accent mb-3"><i class="fas fa-route"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 22</h4>
                                <p class="text-sm text-neutral">Path Planning Basics</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-accent mb-3"><i class="fas fa-map-marked-alt"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 23</h4>
                                <p class="text-sm text-neutral">Autonomous Navigation</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-accent mb-3"><i class="fas fa-paw"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 24</h4>
                                <p class="text-sm text-neutral">Quadruped Robot – Part 1</p>
                            </div>

                            <div class="bg-light rounded-xl p-5 shadow-md card-hover">
                                <div class="text-3xl text-accent mb-3"><i class="fas fa-user-alt"></i></div>
                                <h4 class="font-bold text-neutral mb-2">Session 27</h4>
                                <p class="text-sm text-neutral">Bionic Arm – Part 1</p>
                            </div>
                        </div>

                        <div class="text-center mt-8">
                            <button class="text-accent font-medium flex items-center justify-center mx-auto">
                                See all 10 sessions <i class="fas fa-arrow-down ml-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- Projects Showcase --> */}
            <section id="projects" class="py-16 bg-gradient-to-b from-white to-blue-50 px-4">
                <div class="container mx-auto">
                    <h2 class="text-3xl font-bold text-center text-neutral mb-2">Awesome <span class="text-primary">Projects</span> You'll Build</h2>
                    <p class="text-center text-neutral mb-12 max-w-2xl mx-auto">Hands-on learning with exciting robotics projects</p>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {/* <!-- Project 1 --> */}
                        <div class="bg-white rounded-xl overflow-hidden shadow-lg card-hover">
                            <div class="h-48 bg-blue-100 flex items-center justify-center">
                                <img src="https://cdn-icons-png.flaticon.com/512/6412/6412912.png" alt="Robot Car" class="h-40" />
                            </div>
                            <div class="p-6">
                                <h3 class="text-xl font-bold text-neutral mb-2">Robot Car</h3>
                                <p class="text-neutral mb-4">Build and program your own robot car that can move in all directions and avoid obstacles.</p>
                                <div class="flex items-center text-sm text-primary">
                                    <span class="mr-2">Sessions 8-10</span>
                                    <i class="fas fa-robot"></i>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Project 2 --> */}
                        <div class="bg-white rounded-xl overflow-hidden shadow-lg card-hover">
                            <div class="h-48 bg-green-100 flex items-center justify-center">
                                <img src="https://cdn-icons-png.flaticon.com/512/4712/4712035.png" alt="Biped Robot" class="h-40" />
                            </div>
                            <div class="p-6">
                                <h3 class="text-xl font-bold text-neutral mb-2">Otto Biped Robot</h3>
                                <p class="text-neutral mb-4">Create a walking robot that can dance, avoid obstacles, and interact with its environment.</p>
                                <div class="flex items-center text-sm text-secondary">
                                    <span class="mr-2">Sessions 15-17</span>
                                    <i class="fas fa-walking"></i>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Project 3 --> */}
                        <div class="bg-white rounded-xl overflow-hidden shadow-lg card-hover">
                            <div class="h-48 bg-amber-100 flex items-center justify-center">
                                <img src="https://cdn-icons-png.flaticon.com/512/3443/3443248.png" alt="Robotic Arm" class="h-40" />
                            </div>
                            <div class="p-6">
                                <h3 class="text-xl font-bold text-neutral mb-2">6-DOF Robotic Arm</h3>
                                <p class="text-neutral mb-4">Construct a robotic arm with 6 degrees of freedom that can pick and place objects.</p>
                                <div class="flex items-center text-sm text-accent">
                                    <span class="mr-2">Sessions 18-19</span>
                                    <i class="fas fa-hand-paper"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- Benefits Section --> */}
            <section id="benefits" class="py-16 bg-white px-4">
                <div class="container mx-auto">
                    <h2 class="text-3xl font-bold text-center text-neutral mb-2">Why Learn <span class="text-primary">Robotics</span>?</h2>
                    <p class="text-center text-neutral mb-12 max-w-2xl mx-auto">Developing future skills through hands-on robotics education</p>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {/* <!-- Benefit 1 --> */}
                        <div class="text-center">
                            <div class="bg-blue-100 rounded-full h-24 w-24 flex items-center justify-center mx-auto mb-4">
                                <i class="fas fa-cogs text-4xl text-primary"></i>
                            </div>
                            <h3 class="text-xl font-bold text-neutral mb-2">STEM Skills</h3>
                            <p class="text-neutral">Develops strong foundation in Science, Technology, Engineering, and Math</p>
                        </div>

                        {/* <!-- Benefit 2 --> */}
                        <div class="text-center">
                            <div class="bg-green-100 rounded-full h-24 w-24 flex items-center justify-center mx-auto mb-4">
                                <i class="fas fa-lightbulb text-4xl text-secondary"></i>
                            </div>
                            <h3 class="text-xl font-bold text-neutral mb-2">Creativity</h3>
                            <p class="text-neutral">Encourages innovative thinking and problem-solving skills</p>
                        </div>

                        {/* <!-- Benefit 3 --> */}
                        <div class="text-center">
                            <div class="bg-amber-100 rounded-full h-24 w-24 flex items-center justify-center mx-auto mb-4">
                                <i class="fas fa-puzzle-piece text-4xl text-accent"></i>
                            </div>
                            <h3 class="text-xl font-bold text-neutral mb-2">Logical Thinking</h3>
                            <p class="text-neutral">Enhances computational thinking and sequential reasoning</p>
                        </div>

                        {/* <!-- Benefit 4 --> */}
                        <div class="text-center">
                            <div class="bg-purple-100 rounded-full h-24 w-24 flex items-center justify-center mx-auto mb-4">
                                <i class="fas fa-users text-4xl text-purple-600"></i>
                            </div>
                            <h3 class="text-xl font-bold text-neutral mb-2">Teamwork</h3>
                            <p class="text-neutral">Promotes collaboration and communication skills</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- Testimonials --> */}
            <section class="py-16 bg-gradient-to-b from-blue-50 to-white px-4">
                <div class="container mx-auto">
                    <h2 class="text-3xl font-bold text-center text-neutral mb-12">What <span class="text-primary">Parents & Students</span> Say</h2>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {/* <!-- Testimonial 1 --> */}
                        <div class="bg-white p-6 rounded-xl shadow-md">
                            <div class="flex items-center mb-4">
                                <div class="text-yellow-400">
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                </div>
                            </div>
                            <p class="text-neutral mb-4">"My son loved building his first robot car! He's now so interested in technology and how things work."</p>
                            <div class="flex items-center">
                                <div class="bg-blue-100 h-10 w-10 rounded-full flex items-center justify-center mr-3">
                                    <i class="fas fa-user text-primary"></i>
                                </div>
                                <div>
                                    <h4 class="font-bold text-neutral">Savitaben</h4>
                                    <p class="text-sm text-neutral">Parent of 10-year-old</p>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Testimonial 2 --> */}
                        <div class="bg-white p-6 rounded-xl shadow-md">
                            <div class="flex items-center mb-4">
                                <div class="text-yellow-400">
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                </div>
                            </div>
                            <p class="text-neutral mb-4">"The robotics course helped me understand coding in a fun way. I never thought I could build a walking robot!"</p>
                            <div class="flex items-center">
                                <div class="bg-green-100 h-10 w-10 rounded-full flex items-center justify-center mr-3">
                                    <i class="fas fa-user text-secondary"></i>
                                </div>
                                <div>
                                    <h4 class="font-bold text-neutral">Arav Mehera</h4>
                                    <p class="text-sm text-neutral">Student, Age 12</p>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Testimonial 3 --> */}
                        <div class="bg-white p-6 rounded-xl shadow-md">
                            <div class="flex items-center mb-4">
                                <div class="text-yellow-400">
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                </div>
                            </div>
                            <p class="text-neutral mb-4">"As a teacher, I've seen how robotics sparks curiosity and engagement in students who weren't interested in STEM before."</p>
                            <div class="flex items-center">
                                <div class="bg-amber-100 h-10 w-10 rounded-full flex items-center justify-center mr-3">
                                    <i class="fas fa-user text-accent"></i>
                                </div>
                                <div>
                                    <h4 class="font-bold text-neutral">Vignesh</h4>
                                    <p class="text-sm text-neutral">Computer Teacher</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- Contact/Registration Section --> */}
            <section id="contact" class="py-16 bg-white px-4">
                <div class="container mx-auto max-w-4xl">
                    <div class="bg-gradient-to-r from-primary to-blue-700 rounded-2xl shadow-xl overflow-hidden">
                        <div class="md:flex">
                            <div class="md:w-1/2 p-8 text-white">
                                <h2 class="text-2xl font-bold mb-4">Start Your Robotics Journey Today!</h2>
                                <p class="mb-6">Join our next batch of young innovators. Limited seats available.</p>
                                <div class="space-y-4">
                                    <div class="flex items-center">
                                        <div class="bg-white bg-opacity-20 rounded-full h-10 w-10 flex items-center justify-center mr-3">
                                            <i class="fas fa-calendar-alt"></i>
                                        </div>
                                        <div>
                                            <p class="font-semibold">30 Sessions</p>
                                            <p class="text-sm">Over 15 weeks</p>
                                        </div>
                                    </div>
                                    <div class="flex items-center">
                                        <div class="bg-white bg-opacity-20 rounded-full h-10 w-10 flex items-center justify-center mr-3">
                                            <i class="fas fa-users"></i>
                                        </div>
                                        <div>
                                            <p class="font-semibold">Small Groups</p>
                                            <p class="text-sm">Max 8 students per batch</p>
                                        </div>
                                    </div>
                                    <div class="flex items-center">
                                        <div class="bg-white bg-opacity-20 rounded-full h-10 w-10 flex items-center justify-center mr-3">
                                            <i class="fas fa-toolbox"></i>
                                        </div>
                                        <div>
                                            <p class="font-semibold">All Materials Included</p>
                                            <p class="text-sm">No additional costs</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- Footer --> */}
            <footer className="bg-gray-900 text-white">
                <div className={`${styles.spacing.container} pt-16 pb-8`}>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12 mb-12">
                        <div>
                            <h3 className="text-2xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                                CloudTales
                            </h3>
                            <p className="text-gray-400 mb-6">
                                Empowering the next generation through innovative digital education solutions.
                            </p>
                        </div>

                        <div>
                            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
                            <ul className="space-y-4">
                                <li><a href="/#products" className="text-gray-400 hover:text-white transition-colors duration-300">Our Products</a></li>
                                <li><a href="/#workshops" className="text-gray-400 hover:text-white transition-colors duration-300">Workshops</a></li>
                                <li><a href="/#contact" className="text-gray-400 hover:text-white transition-colors duration-300">Contact</a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-gray-800 pt-8 text-center">
                        <p className="text-gray-400">&copy; 2025 CloudTales Technologies. All rights reserved.</p>
                    </div>
                </div>
            </footer>

        </div>
    </>
    )

}